module.exports = __webpack_public_path__ + "static/media/mockup-ums-2.5f798720.jpg";